export const apiOptions = [
  {
    label: "Catalog API",
    value: "Catalog API",
  },
  {
    label: "End-to-end solution",
    value: "End-to-end solution",
  },
  {
    label: "Checkout API",
    value: "Checkout API",
  },
  {
    label: "merchant ecosystem",
    value: "merchant ecosystem",
  },
  {
    label: "Logistic API",
    value: "Logistic API",
  },
  {
    label: "others",
    value: "others",
  },
];

export const mobileOptions = [
  {
    label: "Catalog API",
    value: "Catalog API",
  },
  {
    label: "Checkout API",
    value: "Checkout API",
  },
  {
    label: "Logistic API",
    value: "Logistic API",
  },
  {
    label: "End-to-end solution",
    value: "End-to-end solution",
  },

  {
    label: "merchant ecosystem",
    value: "merchant ecosystem",
  },
  {
    label: "others",
    value: "others",
  },
];



export const businessOptions = [
  {
    label: "marketplace(APP)",
    value: "marketplace(APP)",
  },
  {
    label: "marketplace(Website)",
    value: "marketplace(Website)",
  },
  {
    label: "publisher",
    value: "publisher",
  },
  {
    label: "shopifyowner",
    value: "shopifyowner",
  },
  {
    label: "merchants",
    value: "merchants",
  },
  {
    label: "brands",
    value: "brands",
  },
  {
    label: "others",
    value: "others",
  },
];

export const revenueOptions = [
  {
    label: "1-1M",
    value: "1-1M",
  },
  {
    label: "1.1-10M",
    value: "1.1-10M",
  },
  {
    label: "11-50M",
    value: "11-50M",
  },
  {
    label: "51-100M",
    value: "51-100M",
  },
  {
    label: "100M+",
    value: "100M+",
  },
];

export const productsOptions = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];